import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import moment from "moment";
import { useLocation } from "react-router-dom";
import CardNft from "Pages/CardNft/CardNft";
import { useSelector, useDispatch } from "react-redux";
import { getHomepage, getItems, getCollectionByAddress } from "store/actions";

const CardProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(location?.search);
  const slug = queryParams.get("id");

  const { user } = useSelector((state) => state?.Login);
  const { items } = useSelector((state) => state?.items);
  const { collection, floorPrice, collectionItems } = useSelector(
    (state) => state?.collections
  );

  const [filter, setfilter] = useState({
    limit: 10,
    orderBy: "_id",
    order: -1,
    page: 1,
    collectedAuthor: "",
    author: "",
    createdAuthor: "",
    collectionId: "",
    fields: [],
    fileType: [],
    isVarified: false,
    getNew: false,
    isMore: false,
    collectionId: collection?._id,
  });
  const [filter1, setfilter1] = useState({
    col_time: "30 days",
  });

  useEffect(() => {
    if (slug) {
      dispatch(getCollectionByAddress(slug));
    }
  }, [slug]);

  useEffect(() => {
    if (user?._id) {
      setfilter1((prev) => ({ ...prev, user_id: user?._id }));
    }
  }, [user?._id]);

  useEffect(() => {
    if (filter1.user_id) {
      dispatch(getHomepage(filter1));
    }
  }, [filter1]);

  useEffect(() => {
    if (collection?._id) {
      setfilter((prevState) => ({
        ...prevState,
        collectionId: collection?._id,
        page: 1,
        isMore: false,
      }));
    }
  }, [collection?._id]);

  useEffect(() => {
    if (user?._id) {
      setfilter((prevState) => ({
        ...prevState,
        user_id: user?._id,
      }));
    }
  }, [user?._id]);

  useEffect(() => {
    if (!filter.collectionId) return;
    dispatch(getItems(filter));
  }, [filter]);

  return (
    <section className="profile-singlewrap card-profilewrap">
      <div className="Profile-single card-profilewrap-single position-relative">
        <div className="overlay-gra"></div>
      </div>
      <Container>
        <div className="profile-content-overlap">
          <div className="profilimg">
            <img src={collection?.image?.link} alt="" className="img-fluid" />
          </div>
          <div className="profile-cont card-profilewrap-cont text-center">
            <h2>{collection?.name}</h2>
            <p className="code-here">
              Created by {collection?.author?.username}
            </p>
            <p className="joined-date">
              Created at -
              {moment(collection?.date_created_utc).format("yyy - MMM -DD")}
            </p>
          </div>

          <div className="three-box-div">
            <div className="divboxone">
              <h5 className="theme-color">{collectionItems}</h5>
              <p>Items</p>
            </div>

            <div className="divboxone">
              <h5 className="theme-color">{floorPrice}</h5>
              <p>Floor Price</p>
            </div>
          </div>
        </div>

        <Row>
          <Col lg={12} md={12} sm={12}>
            {items && items?.length > 0 ? (
              <Row>
                {items?.map((getNftData, idx) => {
                  return (
                    <Col key={idx} lg={3}>
                      <div className="col-details-item">
                        <CardNft getNftData={getNftData} />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            ) : (
              <div className="mt-5">
                <h4 className="head-found">NO Data Found !!</h4>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default CardProfile;
